import React from 'react';
import type { ReviewEvidence as Evidence } from '../lib/review-evidence';
import { useTheme } from '../context/ThemeContext';
import { Section, Field } from './education/Section';

export const ReviewEvidence: React.FC<{ review: Evidence }> = ({ review }) => {
  const { theme } = useTheme();
  if (!review.reviewed_at && !review.sources?.length && !review.notes?.length) return null;
  return <Section title="Reviewed evidence">
    <Field label="Source review" value={review.reviewed_at} />
    {review.sources?.map((source, i) => <div key={`${source.url}-${i}`} style={{ fontSize: 12, lineHeight: 1.5, marginTop: 10, overflowWrap: 'anywhere' }}>
      <a href={source.url} target="_blank" rel="noopener noreferrer" style={{ color: theme.text }}>{source.title}</a>
      <div style={{ color: theme.textSecondary }}>
        {source.published_at ? `Published ${source.published_at}` : 'Publication date unknown'}
        {source.accessed_at ? ` · Checked ${source.accessed_at}` : ''}
      </div>
    </div>)}
    {review.notes?.map((note, i) => <p key={i} style={{ color: theme.textSecondary, fontSize: 12, lineHeight: 1.5 }}>{note}</p>)}
  </Section>;
};
